export default "__VITE_ASSET__b889136f__"